var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * HierarchyFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconHierarchyFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_17918_85)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.3567 0.571289C9.0352 0.571289 7.96387 1.64261 7.96387 2.96415V6.24986C7.96387 7.57139 9.03519 8.64272 10.3567 8.64272H11.2307C11.1546 9.29919 10.8593 9.91477 10.3873 10.3867C9.83472 10.9393 9.0853 11.2497 8.30385 11.2497C7.12458 11.2497 5.99362 11.7182 5.15975 12.5521C4.4062 13.3056 3.95106 14.3018 3.87037 15.3569H2.96415C1.6426 15.3569 0.571289 16.4283 0.571289 17.7498V21.0355C0.571289 22.3571 1.64261 23.4284 2.96415 23.4284H6.24986C7.57138 23.4284 8.64272 22.3571 8.64272 21.0355V17.7498C8.64272 16.4283 7.57139 15.3569 6.24986 15.3569H5.377C5.45308 14.7004 5.7484 14.0847 6.22041 13.6127C6.77298 13.0601 7.5224 12.7497 8.30385 12.7497C9.48312 12.7497 10.6141 12.2813 11.4479 11.4474C11.6551 11.2403 11.8397 11.0148 12.0001 10.7748C12.1606 11.0148 12.3452 11.2403 12.5523 11.4474C13.3862 12.2813 14.5172 12.7497 15.6964 12.7497C16.4778 12.7497 17.2272 13.0601 17.7798 13.6127C18.2518 14.0847 18.5472 14.7004 18.6233 15.3569H17.7503C16.4287 15.3569 15.3574 16.4283 15.3574 17.7498V21.0355C15.3574 22.3571 16.4288 23.4284 17.7503 23.4284H21.036C22.3576 23.4284 23.4289 22.3571 23.4289 21.0355V17.7498C23.4289 16.4283 22.3576 15.3569 21.036 15.3569H20.1299C20.0492 14.3017 19.594 13.3056 18.8406 12.5521L18.8405 12.552C18.0066 11.7182 16.8757 11.2497 15.6964 11.2497C14.915 11.2497 14.1656 10.9393 13.613 10.3867C13.141 9.91477 12.8457 9.29919 12.7696 8.64272H13.6424C14.964 8.64272 16.0353 7.57139 16.0353 6.24986V2.96415C16.0353 1.64261 14.964 0.571289 13.6424 0.571289H10.3567Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_17918_85">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconHierarchyFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconHierarchyFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconHierarchyFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-hierarchy-filled') === undefined) {
    customElements.define('cat-icon-hierarchy-filled', BlocksIconHierarchyFilled);
}
